export default __webpack_public_path__ + "static/media/YELLOW_PAGES.f38ce824.png";